import { render, staticRenderFns } from "./customers.vue?vue&type=template&id=bf8af4e0&scoped=true&lang=pug"
import script from "./customers.vue?vue&type=script&lang=js"
export * from "./customers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8af4e0",
  null
  
)

/* custom blocks */
import block0 from "./customers.vue?vue&type=custom&index=0&blockType=router"
if (typeof block0 === 'function') block0(component)

export default component.exports